const t = {
  name: "TurnRight",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.5856 4.00012L11.5856 2.00015L12.9998 0.585938L17.4141 5.00015L12.9998 9.41436L11.5856 8.00015L13.5857 6.00012H12C8.13229 6.00012 5 9.13241 5 13.0001C5 16.8678 8.13229 20.0001 12 20.0001C15.8677 20.0001 19 16.8678 19 13.0001H21C21 17.9724 16.9723 22.0001 12 22.0001C7.02771 22.0001 3 17.9724 3 13.0001C3 8.02784 7.02771 4.00012 12 4.00012H13.5856Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as TurnRight
};
